// extracted by mini-css-extract-plugin
export default {"tabs":"aHih1f"};